import axios from "axios";

export default class AxiosRequest {
    handleError(error) {
        return error
        /*if(error.response) {
            console.error('AjaxRequest Error, Response: ', error);
            return error.response.data;
        } else if (error.request) {
            feedback('The Request failed. Please try again.', 'danger');
            console.error('AjaxRequest Error, Request: ', error);
            return error.request;
        } */
        // else {
        //     console.log("error",error)
        //     feedback('Something failed on request. Please try again.', 'danger');
        //     console.error('AjaxRequest Error, Message: ', error);
        //     return error.message;
        // }
    }

    handleResponse(response) {
        // if(!response.success) {
        //     console.error('Failed Response: ', response.message);
        //     console.error('Failed Reason: ', response.exception.message);
        //     feedback(response.message, 'danger');
        //     return response;
        // }
        return response;
    }

    get(url, data = {}) {
        const self = this;
        return axios.get(url, {params: data}).then(function (response) {
            return self.handleResponse(response);
        }).catch((error) => {
            throw new Error(error);
        });
    }

    post(url, data = {}, config = null) {
        const self = this;
        return axios.post(url, data, config).then(function (response) {
            return self.handleResponse(response);
        }).catch((error) => {
            throw new Error(error);
        });
    }

    patch(url, data = {}) {
        const self = this;
        return axios.patch(url, data).then(function (response) {
            return self.handleResponse(response);
        }).catch((error) => {
            throw new Error(error);
        });
    }

    delete(url, data = {}) {
        const self = this;
        return axios.delete(url, {params: data}).then(function (response) {
            return self.handleResponse(response);
        }).catch((error) => {
            throw new Error(error);
        });
    }
}
